import React from 'react';
import toCurrency from 'utils/toCurrency';
import { getCatalogoDelMes } from 'api/catalogos';
import PlainCRUD from 'components/PaginatedPlainCRUD';
import {
  getINPCs, postINPCs, patchINPC, deleteINPc,
} from 'api/configuracion';
import { getPeriodosFiscales } from 'api/catalogos/periodosFiscales';
// eslint-disable-next-line react/prop-types
const INPC = ({ permission }) => (
  <PlainCRUD
    title="INPC"
    permission={permission}
    get={getINPCs}
    post={postINPCs}
    patch={patchINPC}
    delete={deleteINPc}
    fields={[
      {
        name: 'periodo',
        label: 'Periodo fiscal',
        required: true,
        colWidth: 200,
      },
      {
        name: 'valor',
        label: 'Valor',
        type: 'decimal',
        render: (val) => toCurrency(val),
        required: true,
        decimal: true,
        colWidth: 200,
        colAlign: 'right',
      },
      {
        name: 'mes',
        label: 'Mes',
        // render: (item) => item.descripcion,
        labelProp: 'descripcion',
        type: 'select',
        required: true,
        colWidth: 200,
        useCatalog: true,
      },
    ]}
    catalogs={[
      {
        permission: 'catalogodemes',
        get: getCatalogoDelMes,
        formItemName: 'mes',
      },
      {
        permission: 'periodofiscal',
        get: getPeriodosFiscales,
        formItemName: 'periodo',
        extractor: (data) => data.map((item) => ({
          ...item,
          descripcion: `${item.periodo} - ${item.identificador}`,
        })),
      },
    ]}
  />
);

export default INPC;
